import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { MagnifyIcon, QuestionIcon, SettingsIcon } from "../../icons";

function Header({
  signedIn,
  slot,
  version,
  userDetails,
  userInitials,
  userName,
  showSearch,
  showSettings,
  empty = false,
}) {
  const className =
    "navbar sticky-top d-flex flex-shrink-0 align-items-center justify-content-between";

  // Still drawn when empty: the fixed logo block sits in its corner.
  if (empty) {
    return <nav id="header" className={className} />;
  }

  return (
    <nav id="header" className={className}>
      <ul className="nav align-items-center gap-3">
        {signedIn && (
          <li className="nav-item">
            <Link
              to="/help"
              className="nav-link d-flex align-items-center gap-2"
              aria-label="Open help"
              title="Help"
            >
              <FontAwesomeIcon icon={QuestionIcon} />
              <span>Help</span>
            </Link>
          </li>
        )}
        {signedIn && showSearch && (
          <li className="nav-item">
            <Link
              to="/search"
              className="nav-link d-flex align-items-center gap-2"
            >
              <FontAwesomeIcon icon={MagnifyIcon} />
              <span>Search</span>
            </Link>
          </li>
        )}
      </ul>
      {signedIn && (
        <ul className="nav align-items-center gap-3">
          {showSettings && (
            <li className="nav-item">
              <Link
                to="/settings"
                className="nav-link d-flex align-items-center gap-2"
              >
                <FontAwesomeIcon icon={SettingsIcon} />
                <span>Settings</span>
              </Link>
            </li>
          )}
          {version && (
            <li className="nav-item text-nowrap">Version: {version}</li>
          )}
          {userDetails && (
            <>
              <li id="header-divider" aria-hidden="true" />
              <li className="nav-item d-flex align-items-center gap-2">
                <span id="header-avatar">{userInitials}</span>
                <span id="header-username">{userName}</span>
              </li>
            </>
          )}
          <li className="nav-item text-nowrap">
            <a href="/.auth/logout" className="nav-link">
              Sign out
            </a>
          </li>
        </ul>
      )}
    </nav>
  );
}

export default Header;
